const controllers = require.context('.', true, /.js$/)
controllers.keys().forEach(controllers)
